/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchContainersResponse } from './search-containers-response';


export interface SearchContainersResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchContainersResponse> | null;
}

